import { HorizontalContainer } from '@/components';
import { GhostIconButton } from '@/components';
import {
    CloseIcon,
    MaximizeIcon,
    OpenLinkIcon,
    RotateLeftIcon,
    RotateRightIcon,
} from '@/components/Icons';

import { R } from '@/caregiverSpace/resources/Texts.resx';

type ViewerToolbarProps = {
    fileName: string;
    fileUrl: string;
    onClose: () => void;
    onFullscreen: () => void;
    onRotateLeft?: () => void;
    onRotateRight?: () => void;
};

export const ViewerToolbar = ({
    fileName,
    fileUrl,
    onClose,
    onFullscreen,
    onRotateLeft,
    onRotateRight,
}: ViewerToolbarProps) => (
    <HorizontalContainer
        spacing="sm"
        className="shrink-0 items-center justify-between px-4 py-3"
    >
        <span className="truncate text-sm font-medium text-white">
            {fileName}
        </span>
        <HorizontalContainer spacing="none" className="items-center gap-3">
            {onRotateLeft && (
                <GhostIconButton
                    aria-label={R.RotateLeft}
                    onClick={onRotateLeft}
                >
                    <RotateLeftIcon />
                </GhostIconButton>
            )}
            {onRotateRight && (
                <GhostIconButton
                    aria-label={R.RotateRight}
                    onClick={onRotateRight}
                >
                    <RotateRightIcon />
                </GhostIconButton>
            )}
            <GhostIconButton
                aria-label={R.EnterFullscreen}
                onClick={onFullscreen}
            >
                <MaximizeIcon />
            </GhostIconButton>
            <a
                href={fileUrl}
                target="_blank"
                rel="noreferrer"
                aria-label={R.OpenInNewTab}
                className="flex items-center p-1 text-white/70 hover:text-white"
            >
                <OpenLinkIcon />
            </a>
            <GhostIconButton aria-label={R.Close} onClick={onClose}>
                <CloseIcon />
            </GhostIconButton>
        </HorizontalContainer>
    </HorizontalContainer>
);
